export interface DataItem<valueType> {
    name: string;
    value: valueType;
}

export interface ChartDataItem<valueType> extends DataItem<valueType> {
    color: string;
}
